import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {MatIconModule} from '@angular/material/icon';
import {EmOperandIconModule} from '../operand-icon/operand-icon.module';
import {EmOperandLabelModule} from '../operand-label/operand-label.module';
import {EmOperandWithIconComponent} from './operand-with-icon.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    EmOperandIconModule,
    EmOperandLabelModule,
  ],
  declarations: [EmOperandWithIconComponent],
  exports: [EmOperandWithIconComponent],
})
export class EmOperandWithIconModule {}
